export const ROUTE_LANDING_PAGES = '/landing-pages';
export const SUBROUTE_CREATE_LANDING_PAGE = '/create';
export const SUBROUTE_EDITOR = '/editor';
export const SUBROUTE_ADMIN_TEMPLATES = '/landing-pages';

export const LANDING_PAGES_QUERY_KEY_PREFIX = 'landing-pages';

export const SUBROUTE_SCHEDULE = '/schedule';
export const LANDING_PAGE_SCHEDULE_EVENTS_QUERY_KEY_PREFIX =
  'landing-page-schedule-events';
export const LARGE_ENTITY_FETCH_LIMIT = 100;

export const LIST_BREADCRUMB_TEXT = 'View all landing pages';
